// Corvin checks for a tip once per browser session; the tip and whether it
// was closed live here so a reload doesn't fetch again. Each entry is tagged
// with its user: a tip can name another shop's customer, so an entry that
// isn't the current user's is never shown. Storage can throw (private mode,
// blocked site data): then Corvin just shows nothing, which is harmless.
export const SESSION_KEY = 'corvin';

export function readSession(userId) {
  try {
    const value = JSON.parse(sessionStorage.getItem(SESSION_KEY));
    return value && value.userId === userId ? value : null;
  } catch {
    return null;
  }
}

export function writeSession(value) {
  try {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(value));
  } catch {
    /* see above */
  }
}

export function clearSession() {
  try {
    sessionStorage.removeItem(SESSION_KEY);
  } catch {
    /* see above */
  }
}
